module.exports = __webpack_public_path__ + "img/bhutan.741902b2.svg";